<template>
    <div class="pageBox">
        <div class="pageFrame">
            <left></left>
            <div class="frame">
                <div class="addBtn" @click="openAddress(0)">
                    <div class="addImg">
                        <span>+</span>
                    </div>
                    <span class="addText">新增地址</span>
                </div>
                <el-table
                    :data="addressList"
                    stripe
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="收货人"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="contact"
                        label="联系方式"
                        width="130"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="地区"
                        width="200"
                    >
                        <div slot-scope="scope">
                            {{ scope.row.province }}
                            {{ scope.row.city }}
                            {{ scope.row.region }}
                        </div>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="detail"
                        width="230"
                        label="详细地址">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="100"
                        label="是否默认">
                        <div slot-scope="scope" class="defaultRow">
                            <span>{{ scope.row.isDefault == 1 ? '' : '否' }}</span>
                            <div class="defaulted" v-if="scope.row.isDefault==1">已默认</div>
                            <div class="setDefault" @click="setDefaultAddress(scope.row.id)" v-else>设为默认</div>
                        </div>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="operate"
                        label="操作"
                        width="100"
                    >
                        <div class="operationRow" slot-scope="scope">
                            <div @click="openAddress(
                                scope.row.id,
                            scope.row.name,
                            scope.row.contact,
                            scope.row.province,
                            scope.row.city,
                            scope.row.region,
                            scope.row.detail,
                            scope.row.isDefault,
                            )">编辑
                            </div>
                            <div @click="dropAddressBtn(scope.row.id)">删除</div>
                        </div>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="pageIndex"
                        :page-sizes="[10, 15, 20, 25]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>
                <el-dialog title="收货地址" :visible.sync="isShowDialog" width="600px">
                    <div class="dialog">
                        <div class="itemRow">
                            <span class="red">*</span>
                            <span>收货人：</span>
                            <div class="editCol">
                                <input type="text"
                                       @blur="isNull($event,2)"
                                       placeholder="请输入收货人名称" v-model="consignee">
                                <span class="tips" v-show="isShowTips2">{{ tips2 }}</span>
                            </div>
                        </div>
                        <div class="itemRow">
                            <span class="red">*</span>
                            <span>手机号：</span>
                            <div class="editCol">
                                <input type="number"
                                       @blur="isNull($event,1)"
                                       placeholder="请输入收货人联系方式" v-model="contact">
                                <span class="tips" v-show="isShowTips1">{{ tips1 }}</span>
                            </div>
                        </div>
                        <div class="itemRow">
                            <span class="red">*</span>
                            <span>地区：</span>
                            <div class="editCol">
                                <el-cascader
                                    placeholder="试试搜索："
                                    :options="regionList"
                                    :props="{label:'name',value:'name',children:'sub'}"
                                    filterable
                                    v-model="selectedRegion"
                                    @blur="isNull($event,3)"
                                >
                                </el-cascader>
                                <span class="tips" v-show="isShowTips3">{{ tips3 }}</span>
                            </div>
                        </div>
                        <div class="itemRow">
                            <span class="red">*</span>
                            <span>详细地址：</span>
                            <div class="editCol detail">
                                <textarea type="text"
                                          @blur="isNull($event,4)"
                                          placeholder="请输入收货人详细地址" v-model="addressDetail"/>
                                <span class="tips" v-show="isShowTips4">{{ tips4 }}</span>
                            </div>
                        </div>
                        <div class="itemRow">
                            <span class="red"></span>
                            <span>是否默认：</span>
                            <el-checkbox class="itemRow" v-model="checkedDefault" label="默认"></el-checkbox>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="isShowDialog = false">取 消</el-button>
                        <el-button type="primary" @click="addressOk(addressId)">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import left from './left'
import cityFile from '../../utils/city'

export default {
    name: "reAddress",
    components: {
        left,
    },
    mounted() {
        document.title = '地址管理' + this.$suffix
        this.$store.commit('modifyUserIndex', 2001)
        if (!this.$noLoginToLogin()) {
            this.getAddressList()
        }
    },
    data() {
        return {
            isShowTips1: false,
            isShowTips2: false,
            isShowTips3: false,
            isShowTips4: false,
            tips1: '',
            tips2: '',
            tips3: '',
            tips4: '',
            //收货人信息
            consignee: '',
            contact: '',
            //选择的地区
            selectedRegion: [],
            //详细地址
            addressDetail: '',
            //是否默认地址
            checkedDefault: false,
            //地址id
            addressId: 0,
            //地址列表
            addressList: [],
            pageIndex: 1,
            totalCount: 8,
            pageSize: 10,
            //是否显示新增地址框
            isShowDialog: false,
            //地区列表
            regionList: cityFile.city,
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getAddressList()
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getAddressList()
        },

        /**
         * 打开地址详情
         * @param id 地址id
         * @param name 联系人
         * @param Contact 联系电话
         * @param province 省份
         * @param city 城市
         * @param region 县市区
         * @param detail 详细地址
         * @param isDefault 是否默认
         **/
        openAddress(id, name, contact, province, city, region, detail, isDefault) {
            this.isShowDialog = true
            this.addressId = 0
            if (id > 0) {
                //修改,展示详细地址
                this.addressId = id
                this.consignee = name
                this.contact = contact
                //选择的地区
                this.selectedRegion = []
                if (!this.$isNullOrUndefined(province)) {
                    this.selectedRegion.push(province)
                }
                if (!this.$isNullOrUndefined(city)) {
                    this.selectedRegion.push(city)
                }
                if (!this.$isNullOrUndefined(region)) {
                    this.selectedRegion.push(region)
                }
                //详细地址
                this.addressDetail = detail
                //是否默认地址
                this.checkedDefault = isDefault == 0 ? false : true
            } else {
                //新增，需要置空数据
                this.addressId = 0
                this.consignee = ''
                this.contact = ''
                //选择的地区
                this.selectedRegion = []
                //详细地址
                this.addressDetail = ''
                //是否默认地址
                this.checkedDefault = false
            }
        },

        /**
         * 新增/修改地址按钮
         * @param id 地址id
         **/
        addressOk(id) {
            if (this.consignee == '' || this.contact == '' ||
                this.selectedRegion.length < 1 || this.addressDetail == '') {
                this.$message.warning('请规范填写收货地址！')
            } else {
                this.addOrModifyAddress(id)
                this.isShowDialog = false
            }
        },

        /**
         * 请求新增/修改地址
         **/
        addOrModifyAddress(id) {
            this.$post('/V1/Address/ModiyAddress',
                {
                    "id": Number(id),
                    "userId": Number(this.$store.state.user.userName),
                    "name": this.consignee,
                    "contact": this.contact,
                    "province": this.selectedRegion[0],
                    "city": this.selectedRegion.length > 1 ? this.selectedRegion[1] : '',
                    "region": this.selectedRegion.length > 2 ? this.selectedRegion[2] : '',
                    "detail": this.addressDetail,
                    "isDefault": this.checkedDefault ? 1 : 0
                })
                .then((res) => {
                    // console.log('addAddress', res)
                    if (res.success) {
                        if (id > 0) {
                            this.$message.success("修改地址成功！");
                            // if (this.checkedDefault) {
                            //     this.setDefaultAddress(id)
                            // }else{
                                this.getAddressList()
                            // }
                        } else {
                            this.$message.success("新增地址成功！");
                            this.getAddressList()
                        }
                        //成功则置空
                        this.consignee = ''
                        this.contact = ''
                        this.selectedRegion = null
                        this.addressDetail = ''
                        this.checkedDefault = false
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 获取地址列表
         * @param id 用户id
         */
        getAddressList() {
            this.$post('/V1/Address/GetAddressArrary',
                {
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                    "userId": Number(this.$store.state.user.userName),
                })
                .then((res) => {
                    // console.log('addressList', res)
                    if (res.success) {
                        this.totalCount = res.response.totalCount
                        this.addressList = res.response.data
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 删除收货地址按钮
         * @param id 地址id
         */
        dropAddressBtn(id) {
            this.$confirm('即将删除此地址, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning '
            }).then(() => {
                this.dropAddress(id)
            }).catch(() => {

            })
        },

        /**
         * 删除收货地址
         * @param id 地址id
         */
        dropAddress(id) {
            this.$post('/V1/Address/DeleteAddress',
                {
                    ids: [id]
                })
                .then((res) => {
                    // console.log('drop', res)
                    if (res.success) {
                        this.$message.success("删除地址成功！");
                        this.getAddressList()
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 设置默认收货地址
         * @param id
         */
        setDefaultAddress(id) {
            this.$post('/V1/Address/SetDefaultAddress',
                {
                    "userId": Number(this.$store.state.user.userName),
                    "addressId": Number(id)
                })
                .then((res) => {
                    // console.log('setDefault', res)
                    if (res.success) {
                        this.$message.success("设置默认地址成功！");
                        this.getAddressList()
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 判空
         */
        isNull(e, index) {
            let isShow = false
            let tmp1 = null
            let tmp2 = '不能为空';
            if (e.target.value == '') {
                isShow = true
            }
            switch (index) {
                case 1:
                    if (!isShow) {
                        //判断是否合法
                        if (e.target.value.length != 11 || !this.$isPhone(e.target.value)) {
                            tmp2 = '不规范'
                            isShow = true
                        }
                    }
                    tmp1 = '手机号'
                    this.tips1 = tmp1 + tmp2
                    this.isShowTips1 = isShow
                    break;
                case 2:
                    tmp1 = '收货人'
                    this.tips2 = tmp1 + tmp2
                    this.isShowTips2 = isShow
                    break;
                case 4:
                    tmp1 = '详细地址'
                    this.tips4 = tmp1 + tmp2
                    this.isShowTips4 = isShow
                    break;
            }
        },
    }
}
</script>

<style scoped lang="less">

.pageBox {
    width: 100%;
    background-color: #f9f9f9;

    .pageFrame {
        width: 1210px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        padding: 30px 0px;

        .frame {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            width: 880px;
            padding: 40px;
            overflow: hidden;
            background-color: white;

            .addBtn:hover {
                background-color: #f9f9f9;
                transition: .5s;
            }

            .addBtn {
                border: 1px dashed #e0e0e0;
                border-radius: 5px;
                width: 100px;
                height: 100px;
                margin: 0 auto 30px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                .addImg {
                    width: 50px;
                    height: 50px;
                    overflow: hidden;
                    border-radius: 50%;
                    background-color: #d7d7d7;
                    margin-bottom: 10px;
                    text-align: center;

                    span {
                        font-size: 30px;
                        color: white;
                        line-height: 50px;
                    }
                }

                .addText {
                    font-size: 14px;
                    color: #999;
                }
            }

            .operationRow, .defaultRow {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 80px;
                justify-content: space-around;

                div {
                    color: #1f2d5c;
                    font-size: 14px;
                    cursor: pointer;
                }

                .defaulted {
                    color: #b4b4b4;
                    width: 56px;
                    font-size: 12px;
                }

                .setDefault {
                    width: 56px;
                    font-size: 12px;
                }
            }

            .pagination {
                margin-top: 30px;
            }

            .dialog {
                display: flex;
                flex-direction: column;
                margin: 0 auto;
                width: 450px;
                overflow: hidden;

                .detail {
                    height: 80px;
                }

                .itemRow {
                    display: flex;
                    flex-direction: row;
                    margin: 0px 0px 6px 0px;
                    min-height: 56px;

                    .editCol {
                        display: flex;
                        flex-direction: column;

                        .tips {
                            padding-left: 10px;
                            color: #d50000;
                            font-size: 12px;
                        }
                    }

                    .red {
                        color: red;
                        min-width: 10px;
                    }

                    span {
                        min-width: 90px;
                        font-size: 15px;
                    }

                    input, textarea {
                        color: #606266;
                        border-radius: 5px;
                        padding: 5px 15px;
                        line-height: 26px;
                        font-size: 14px;
                        width: 310px;
                        border: 1px solid #DCDFE6;
                    }

                    input::placeholder, textarea::placeholder {
                        color: #c0c4cc;
                    }

                    ::v-deep .el-cascader .el-input__inner {
                        width: 340px;
                    }
                }
            }
        }
    }
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

</style>
